import React from 'react';
export function Footer() {
  return <footer className="bg-navy-950 py-12 px-4 sm:px-6 lg:px-8 border-t border-navy-800 text-center" data-id="element-99">
      <div className="max-w-4xl mx-auto" data-id="element-100">
        <div className="text-2xl font-bold text-white mb-4" data-id="element-101">
          💑 MATRIMONIO SIN CRISIS
        </div>

        <p className="text-slate-400 mb-8 max-w-2xl mx-auto" data-id="element-102">
          El sistema de rescate y blindaje relacional N°1 para parejas
          latinoamericanas.
          <br data-id="element-103" />
          <br data-id="element-104" />
          Porque tener una relación sana no debería costarte todos los días del
          año sin saber qué hacer.
        </p>

        <div className="text-xs text-slate-500 space-y-2 mb-12" data-id="element-105">
          <p data-id="element-106">© Matrimonio Sin Crisis 2026 — Todos los derechos reservados.</p>
          <p data-id="element-107">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <p className="text-sm font-medium text-blue-400/80 italic" data-id="element-108">
          💑 "La relación más importante que vas a tener en tu vida merece las
          mejores herramientas."
        </p>
      </div>
    </footer>;
}